import React from 'react'
import { confirmable, createConfirmation } from 'react-confirm'
import { Modal } from './UI/Modal'
import { Cross2Icon } from '@radix-ui/react-icons'
import styled from 'styled-components/macro'
import FbButton, { FbButtonVariants } from './FbUI/FbButton'
import { Z_INDEX } from 'styles/z-index'

interface Options {
  confirmLabel?: string
  buttonVariant?: FbButtonVariants
}

interface IDialogConfirm {
  show: boolean
  // eslint-disable-next-line @typescript-eslint/ban-types
  proceed: Function
  confirmation: React.ReactNode | string
  options?: Options
  redMessage?: string
  title: string
  enableEscape?: boolean
}

const DialogConfirm = (props: IDialogConfirm) => {
  const { show, proceed, confirmation, title, redMessage, enableEscape } = props
  return (
    <Modal
      centered
      onHide={() => proceed(false)}
      backdrop={enableEscape ? true : 'static'}
      show={show}
      style={{ zIndex: Z_INDEX.DIALOG_CONFIRM }}
      backdropClassName="!z-[74]"
    >
      <Modal.Header className="flex justify-content-between align-items-center">
        <Modal.Title>{title}</Modal.Title>
        {/* DS2026 close affordance: gray circle that fills on hover. */}
        <button
          type="button"
          onClick={() => proceed(false)}
          aria-label="Close"
          className="rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
          <Cross2Icon className="h-5 w-5" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <span>{confirmation}</span>
        {redMessage && (
          <>
            <br />{' '}
            <ExtraMessageRed className="text-danger">
              {redMessage}
            </ExtraMessageRed>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className={'d-flex'}>
        <FbButton
          style={{ flex: 1 }}
          variant="secondary"
          onClick={() => proceed(false)}
        >
          Cancel
        </FbButton>
        <FbButton
          variant={props.options?.buttonVariant || 'primary'}
          style={{ flex: 1 }}
          onClick={() => proceed(true)}
          data-testid="button-confirm-delete"
        >
          {props.options?.confirmLabel || 'OK'}
        </FbButton>
      </Modal.Footer>
    </Modal>
  )
}

export default function confirm(
  confirmation: React.ReactNode | string,
  title: string,
  redMessage = '',
  options: Options = { confirmLabel: 'OK', buttonVariant: 'primary' }
) {
  return createConfirmation(confirmable(DialogConfirm))({
    confirmation,
    title,
    redMessage,
    options,
  })
}

const ExtraMessageRed = styled.span``
